import { observer } from 'mobx-react-lite';
import Select from 'react-select';
import { Icon } from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';

interface IResolveOptions {
  selectedSubtask: {
    subTaskId: string;
    subTaskName: string;
  };
  resolveOptions: {
    taskId: string;
    taskIndex: number;
    taskName: string;
    subTasks: {
      subTaskId: string;
      subTaskName: string;
    }[];
  }[];
  isLoading: boolean;
  onChangeHandler: any;
  clearHandler: () => void;
}

const iconStyles = {
  position: 'absolute',
  right: '46px',
  top: '50%',
  transform: 'translateY(-50%)',
  height: '20px',
  cursor: 'pointer',
};

function ResolveOptions(props: IResolveOptions) {
  const {
    selectedSubtask,
    resolveOptions,
    isLoading,
    onChangeHandler,
    clearHandler,
  } = props;

  const subTaskOptions = (
    subTasks: {
      subTaskId: string;
      subTaskName: string;
    }[],
  ) => {
    return subTasks.flatMap((subData) => {
      if (selectedSubtask?.subTaskId === subData.subTaskId) return [];
      return {
        id: subData.subTaskId,
        value: `${subData.subTaskName} ${uuid()}`,
        label: `${subData.subTaskName}`,
      };
    });
  };

  const resolveTaskOptionsHandler = () => {
    return resolveOptions?.map((data) => {
      return {
        label: data.taskName,
        options: subTaskOptions(data.subTasks),
      };
    });
  };

  return (
    <div style={{ position: 'relative' }}>
      <Select
        value={{
          label: selectedSubtask?.subTaskName || '',
          value: selectedSubtask?.subTaskId || '',
        }}
        isLoading={isLoading}
        options={resolveTaskOptionsHandler()}
        onChange={onChangeHandler}
      />
      {!isLoading && (
        <Icon
          onClick={clearHandler}
          name="close"
          color="grey"
          style={iconStyles}
        />
      )}
    </div>
  );
}

export default observer(ResolveOptions);
